





































import {
  Vue,
  Prop,
  Watch,
  Component,
} from "@/shared/vuepack";
import * as routes from "@/employer/route-names";
import { FundingOption, Permission, massTransitManualClaimStatusMap } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useEmployerBankSettingsStore } from "@/shared/store/employerBankSettings";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { massTransitManualClaimStatusIcon } from "@/shared/awesomeIconMapper";

@Component
export default class SettingsNavigation extends Vue {
  userStore = useUserStore();
  employerBankSettingsStore = useEmployerBankSettingsStore();
  rolePermissionsStore = useRolePermissionsStore();
  featureFlagStore = useFeatureFlagStore();
  routes = routes;
  activeTab = null;

  @Prop({ required: true })
  employerId: number;

  mounted (): void {
    this.activeTab = this.$route.name;
    this.employerBankSettingsStore.getEmployerBankSettings({employerId: this.employerId});
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName
    });
  }

  get showSecurity (): boolean {
    return true;
  }

  get fundingOption (): FundingOption {
    if (this.userStore.currentEmployer && this.userStore.currentEmployer.fundingOption) {
      return this.userStore.currentEmployer.fundingOption;
    }

    return FundingOption.None;
  }

  get hasPayrollWritePermission (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.PayrollWrite);
  }
  get showMassTransitSettings (): boolean {
    return this.featureFlagStore.featureFlagsAvailable
      && this.featureFlagStore.flags.bend22264EnableMassTransitPlanSettings
      && this.employerBankSettingsStore.isLoaded
      && this.employerBankSettingsStore.employerHasMassTransitPlan;
  }
  get statusIcon () {
    return massTransitManualClaimStatusIcon[this.employerBankSettingsStore.bankSettings.status];
  }
  get statusTitle () {
    return massTransitManualClaimStatusMap[this.employerBankSettingsStore.bankSettings.status];
  }
}

